import bridgeLogo from './../../assets/image/bridge/bridge_logo.png'
import bridgeBanner from './../../assets/image/bridge/bridge_bg.jpg'
import bridgeH5Banner from './../../assets/image/bridge/bridge_h5_bg.jpg'
import React, {useEffect, useState} from 'react';
import './index.css'
const Bridge = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    setIsMobile(/android|iphone|ipad|ipod|blackberry|windows phone/i.test(userAgent));
  }, []);

  return (
    <div className="bridge-container">
      {
        isMobile?(
          <div className="vaisa-h5-nav flex">Bridge</div>
        ): (
          <div className="bridge-nav w-1340 flex">
            <div className="bridge-logo">
              <img src={bridgeLogo}/>
            </div>
            <div className="bridge-title">Bridge</div>
            <div className="bridge-btn">
              Lunch App
            </div>
          </div>
        )
      }

      <div className="bridge-content" style={isMobile ? {marginTop: '44px'} : null}>
        <img src={isMobile ? bridgeH5Banner : bridgeBanner} className="banner"/>
        {
          isMobile?(
            <img src={bridgeLogo} className="bridge-content-logo"/>
          ):null
        }

      </div>

    </div>
  );
}

export default Bridge;